import { Component, HostBinding, Input } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-claro-progress-bar',
  templateUrl: './claro-progress-bar.component.html',
  styleUrl: './claro-progress-bar.component.scss',
})
export class ClaroProgressBarComponent extends BaseComponent {
  @Input() value: number = 0;
  // @Input() width: string = '0px';
  @Input() width: string = '100%';
  @Input() height: string = '0px';
  @Input() fillColor: string = '#2196F3';
  @Input() backgroundColor: string = '#DDDDDD';

  @HostBinding('style.width') get progressBarWidth() {
    return this.width;
  }

  constructor() {
    super();
  }


}
